import React from 'react'
import styled from 'styled-components'
import { ModalFooterProps, StyledModalFooterProps } from './modal-footer.types'

export const StyledModalFooter = styled.div<StyledModalFooterProps>`
  ${({ theme, $justify }) =>
    `
    position: sticky;
    bottom: 0;
    z-index: 1;
    background: ${theme.colors.white};
    display: flex;
    justify-content: ${$justify};
    padding: ${theme.sizes[6]};
    gap: ${theme.sizes[4]};
    border-radius: 0 0 var(--lemonade-modal-radius) var(--lemonade-modal-radius);
  `}
`
export const ModalFooter = ({
  justify = 'flex-end',
  children,
}: ModalFooterProps) => {
  return <StyledModalFooter $justify={justify}>{children}</StyledModalFooter>
}
